import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown" }

import { ref, useTemplateRef, onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    minwidth: { default: "12em" }
  },
  setup(__props: any, { expose: __expose }) {

__expose({
	updateHeight,
});

const props = __props;

const forcedOpen = ref(false);
const element = useTemplateRef("element");
const content = useTemplateRef("content");

onMounted(() => {
	updateHeight();
});

function updateHeight() {
	element.value?.setAttribute(
		"style",
		`--unrolled-height: calc(1em + ${content.value?.clientHeight}px); --min-width: ${props.minwidth}`
	);
}

function toggleKeepOpen() {
	setKeepOpen(!forcedOpen.value);
}

function setKeepOpen(open: boolean) {
	if (forcedOpen.value === open) return;
	forcedOpen.value = open;
	if (forcedOpen.value) {
		element.value?.addEventListener("pointerdown", stopPropagation);
		document.addEventListener("pointerdown", onOutsideClick, { once: true });
	} else {
		element.value?.removeEventListener("pointerdown", stopPropagation);
		document.removeEventListener("pointerdown", onOutsideClick);
	}
	updateHeight();
}

function onOutsideClick() {
	setKeepOpen(false);
}

function stopPropagation(e: Event) {
	e.stopPropagation();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["dropdown-container", { 'forced-open': forcedOpen.value }]),
    onMouseenter: updateHeight,
    ref_key: "element",
    ref: element
  }, [
    _createElementVNode("div", {
      class: "handle",
      onPointerdown: toggleKeepOpen
    }, [
      _renderSlot(_ctx.$slots, "handle")
    ], 32 /* NEED_HYDRATION */),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "content",
        ref_key: "content",
        ref: content
      }, [
        _renderSlot(_ctx.$slots, "dropdown")
      ], 512 /* NEED_PATCH */)
    ])
  ], 34 /* CLASS, NEED_HYDRATION */))
}
}

})